const GraphQLQuery = require('app/graphql/Query');
const ListTable = require('app/ui/list/Table');

class IndexView {
    defaultOptions() {
        return {
            'selector': '.view-dashboard',

            'latestOrderLength': 25,
            'latestOrderShowAllUrl': '#',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.drawYesterdayData = this.drawYesterdayData.bind(this);
        this.drawTodayData = this.drawTodayData.bind(this);
        this.drawPreviousMonthData = this.drawPreviousMonthData.bind(this);
        this.drawMonthData = this.drawMonthData.bind(this);

        this.onSummaryFormSubmit = this.onSummaryFormSubmit.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.$latestOrderTableContainer = $('.dashboard-order-latest-table-container',this.$container);

        this.$dailyOrdersCard = $('.card-daily-orders',this.$container);
        this.$monthOrdersCard = $('.card-month-orders',this.$container);
        this.$dailyCACard = $('.card-daily-ca',this.$container);
        this.$monthCACard = $('.card-month-ca',this.$container);

        this.$summaryForm = $('.dashboard-order-summary-form',this.$container);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.initializeSummaryForm();

        this.initializeDailyOrdersCard();
        this.initializeMonthOrdersCard();
        this.initializeDailyCACard();
        this.initializeMonthCACard();
        this.initializeLatestOrderTable();

        this.loadYesterdayData();
        this.loadTodayData();
        this.loadPreviousMonthData();
        this.loadMonthData();

        this.$summaryForm.trigger('submit');
    }

    initializeSummaryForm(){

        this.$supplierDistributionContainer = $('.dashboard-order-summary-supplier-distribution-container',this.$container);
        this.$caCumulationContainer = $('.dashboard-order-summary-ca-cumulation-container',this.$container);
        this.$countCumulationContainer = $('.dashboard-order-summary-count-cumulation-container',this.$container);


        this.$selectMonth = $('select[name="month"]',this.$summaryForm);
        this.$selectSupplier = $('select[name="supplier"]',this.$summaryForm);

        this.$selectMonth.on('change',this.onSummaryFormSubmit);
        this.$selectSupplier.on('change',this.onSummaryFormSubmit);
        this.$summaryForm.on('submit',this.onSummaryFormSubmit);
    }

    onSummaryFormSubmit(event){
        event.stopPropagation();
        event.preventDefault();

        let month = this.$selectMonth.val();
        let supplier = this.$selectSupplier.val();


        this.loadSummaryData(month,supplier);
    }

    clearSummaryContent(){
        this.$supplierDistributionContainer.hide();
        $('.content',this.$supplierDistributionContainer).html('');
        this.$caCumulationContainer.hide();
        $('.content',this.$caCumulationContainer).html('');
        this.$countCumulationContainer.hide();
        $('.content',this.$countCumulationContainer).html('');
    }

    loadSummaryData(month,supplier){
        this.clearSummaryContent();

        var self = this;
        if(!month){
            return;
        }

        let dateStart = month + '-01';
        let momentDay = moment(dateStart);
        let dateEnd = momentDay.endOf('month').format('YYYY-MM-DD');

        let filters = {
            'createdAt': 'BETWEEN ' + dateStart + ' ' + dateEnd,
            'status': 1,
        };
        if(supplier){
            filters.supplier = parseInt(supplier);
        }

        let parameters = {
            'first': 100000,//force to have all lines
            'orderBy': 'createdAt',
            'dir': 'ASC',
            'filter' : filters
        };

        let fields = [
            'supplier { id name }',
            'total',
            'netSale',
            'createdAt',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantOrders',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.drawSummaryData(month,supplier,data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();

    }

    computeSummaryData(month,supplier,data){
        let dateStart = month + '-01';
        let momentDayEnd = moment(dateStart).endOf('month');
        let dateEnd = momentDayEnd.format('YYYY-MM-DD');

        let firstDay = 1;
        let lastDay = parseInt(momentDayEnd.format('DD'));

        let computedData = {
            'bySuppliers' : {},
            'countByDay': {},
            'caByDay': {},
            'cumulCountByDay': {},
            'cumulCAByDay': {},
            'labels': [],
            'chartData': {
                'cumulCA': [],
                'cumulCount': [],
            }
        };

        let edges = data.edges;
        for(var e in edges){
            let line = edges[e];
            let item = line.node;

            let createdAt = item.createdAt;
            let total = parseFloat(item.netSale);
            let supplierId = item.supplier.id;
            let supplierName = item.supplier.name;


            let momentDate = moment(createdAt);
            let day = momentDate.format('YYYY-MM-DD');


            if(!computedData.countByDay[day]){
                computedData.countByDay[day] = 0;
            }
            if(!computedData.countByDay[day]){
                computedData.caByDay[day] = 0;
            }
            if(!computedData.bySuppliers[supplierId]){
                computedData.bySuppliers[supplierId] = {
                    'name': supplierName,
                    'totalCount': 0,
                    'totalCA': 0,
                };
            }

            computedData.countByDay[day] += 1;
            computedData.caByDay[day] += total;
            computedData.bySuppliers[supplierId].totalCount += 1;
            computedData.bySuppliers[supplierId].totalCA += total;
        }

        let previousDay = null;
        for(var i=firstDay; i<=lastDay;i++){
            let day = i;
            if(day < 10){
                day = '0'+i;
            }
            let currentDay = month+'-'+day;

            computedData.labels.push(day);

            computedData.cumulCountByDay[currentDay] = computedData.countByDay.hasOwnProperty(currentDay) ? computedData.countByDay[currentDay] : 0;
            if(previousDay){
                computedData.cumulCountByDay[currentDay] +=  computedData.cumulCountByDay.hasOwnProperty(previousDay) ? computedData.cumulCountByDay[previousDay] : 0;
            }
            computedData.cumulCAByDay[currentDay] =  computedData.caByDay.hasOwnProperty(currentDay) ? computedData.caByDay[currentDay] : 0;
            if(previousDay){
                computedData.cumulCAByDay[currentDay] += computedData.cumulCAByDay.hasOwnProperty(previousDay) ? computedData.cumulCAByDay[previousDay] : 0;
            }

            computedData.chartData.cumulCA.push(computedData.cumulCAByDay[currentDay]);
            computedData.chartData.cumulCount.push(computedData.cumulCountByDay[currentDay]);

            previousDay = currentDay;
        }

        return computedData;
    }

    showSummaryContent(){
        this.$supplierDistributionContainer.show();
        this.$caCumulationContainer.show();
        this.$countCumulationContainer.show();
    }

    giveColor(index){
        let colors = [
            '#8bc4a2',
            '#cfa320',
            '#b8213c',
            '#2669ac',
            '#bede65',
            '#d9ef1d',
            '#a465de',
            '#de6565',
            '#65deaf',
            '#432954',
            '#DD9999',
            '#ff0000',
            '#e9d654',
            '#737c73',
            '#6bf68f',
            '#f7c51f',
            '#1741bb',
            '#29e282',
            '#92cc82',
            '#7ee9f4',
            '#b7c454',
            '#96c14e',
            '#6df2eb',
            '#9d644f',
            '#4f01cd',
            '#871d92',
            '#1e4994',
            '#a6f8b2',
            '#ab97e9',
            '#4403c5',
            '#5dca32',
            '#107e62',
            '#3fd40b',
            '#71ade3',
            '#430fd5',
            '#515bf7',
            '#0be741',
            '#6d847e',
            '#3ceb91',
            '#d066bc',
            '#1e4851',
            '#ef3e35',
            '#9ae481',
            '#4b439e',
            '#bb0eb3',
            '#5491d0',
            '#af5599',
            '#bd916a',
            '#f7eb5b',
            '#3df7f4',
            '#d22daa',
            '#13c42e',
            '#ea19d7',
            '#9975ff',
            '#8ac0a1',
            '#fa1288',
            '#10f8d2',
            '#84d812',
            '#b72fc0',
            '#34847f',
            '#02e6d9',
            '#6862e3',
            '#6b498f',
            '#0ea15a',
            '#399dc5',
            '#334de4',
            '#178eba',
            '#726cd7',
            '#ed694f',
            '#3d9d60',
            '#17f8b4',
            '#4dd6ab',
            '#a3add0',
            '#fd878b',
            '#f78a1a',
            '#d1451f',
            '#050233',
            '#58286f',
            '#821cad',
            '#ad6ff7',
            '#45fa5f',
            '#2419f1',
            '#d6b263',
            '#257288',
            '#d5e433',
            '#0eb603',
            '#6cc193',
            '#77153e',
            '#3fdbea',
            '#d08690',
            '#d1cf62',
            '#9551f9',
            '#cf69a3',
            '#d937fa',
            '#ee54cf',
            '#e5546a',
            '#b687c7',
            '#66302d',
            '#8a6723',
            '#ecd836',
        ];
        //@todo trouver un meilleur systeme pour les couleurs
        return colors[parseInt(index)];
    }

    drawSummaryData(month,supplier,data){
        let computedData = this.computeSummaryData(month,supplier,data);
        
        this.showSummaryContent();

        let monthExploded = month.split('-');
        let monthNumber = parseInt(monthExploded[1]);

        let monthLabel = window.translate('month'+monthNumber) + ' ' + monthExploded[0];
        $('.month-label',this.$supplierDistributionContainer)
        .html('')
        .append(monthLabel);

        $('.month-label',this.$caCumulationContainer)
        .html('')
        .append(monthLabel);
        
        $('.month-label',this.$countCumulationContainer)
        .html('')
        .append(monthLabel);

        if(!supplier){
            this.drawSupplierCountChart(computedData);
        }else{
            this.$supplierDistributionContainer.hide();
        }

        this.drawSupplierCAChart(computedData);
        this.drawCumulCaChart(computedData);
        this.drawCumulCountChart(computedData);
    }

    drawCumulCaChart(computedData){

        let chartConfig = {
            'type': 'line',
            'options': {
                'plugins':{
                    'legend':{
                        'display': false,
                    }
                }
            },
            'data': {
                'labels': computedData.labels,
                'datasets': [{
                    'label': '',
                    'backgroundColor': 'rgb(255, 99, 132)',
                    'borderColor': 'rgb(255, 99, 132)',
                    'data': computedData.chartData.cumulCA,
                }]
            }
        };

        let $chartContainer = $('.dashboard-order-summary-ca-cumulation-graph',this.$container);
        let chartId = window.uniqid();
        let $chart = $('<canvas/>')
        .attr('id',chartId);
        $chartContainer.append($chart);
        let cumulCAChart = new Chart(
            document.getElementById(chartId),
            chartConfig
        );

    }

    drawCumulCountChart(computedData){

        let chartConfig = {
            'type': 'line',
            'options': {
                'plugins':{
                    'legend':{
                        'display': false,
                    }
                }

            },
            'data': {
                'labels': computedData.labels,
                'datasets': [{
                    'label': '',
                    'backgroundColor': 'rgb(255, 99, 132)',
                    'borderColor': 'rgb(255, 99, 132)',
                    'data': computedData.chartData.cumulCount,
                }]
            }
        };

        let $chartContainer = $('.dashboard-order-summary-count-cumulation-graph',this.$container);
        let chartId = window.uniqid();
        let $chart = $('<canvas/>')
        .attr('id',chartId);
        $chartContainer.append($chart);
        let cumulCAChart = new Chart(
            document.getElementById(chartId),
            chartConfig
        );

    }

    drawSupplierCountChart(computedData){

        let labels = [];
        let data = [];
        let colors = [];

        let suppliersKeys = Object.keys(computedData.bySuppliers);
        for(var i in suppliersKeys){
            let supplierId = suppliersKeys[i];
            let supplierData = computedData.bySuppliers[supplierId];

            labels.push(supplierData.name);
            data.push(supplierData.totalCount);
            colors.push(this.giveColor(i));
        }

        let chartConfig = {
            'type': 'doughnut',
            'options': {
                'plugins':{
                    'legend':{
                        'display': false,
                    }
                }

            },
            'data': {
                'labels': labels,
                'datasets': [{
                    'label': '',
                    'hoverOffset': 4,
                    'backgroundColor': colors,
                    'data': data,
                }]
            }
        };

        let $chartContainer = $('.dashboard-order-summary-supplier-distribution-count-graph',this.$container);
        let chartId = window.uniqid();
        let $chart = $('<canvas/>')
        .attr('id',chartId);
        $chartContainer.append($chart);
        let cumulCAChart = new Chart(
            document.getElementById(chartId),
            chartConfig
        );

    }

    drawSupplierCAChart(computedData){

        let labels = [];
        let data = [];
        let colors = [];

        let suppliersKeys = Object.keys(computedData.bySuppliers);
        for(var i in suppliersKeys){
            let supplierId = suppliersKeys[i];
            let supplierData = computedData.bySuppliers[supplierId];

            labels.push(supplierData.name);
            data.push(supplierData.totalCA);
            colors.push(this.giveColor(i));
        }

        let chartConfig = {
            'type': 'doughnut',
            'options': {
                'plugins':{
                    'legend':{
                        'display': false,
                    }
                }

            },
            'data': {
                'labels': labels,
                'datasets': [{
                    'label': '',
                    'hoverOffset': 4,
                    'backgroundColor': colors,
                    'data': data,
                }]
            }
        };

        let $chartContainer = $('.dashboard-order-summary-supplier-distribution-ca-graph',this.$container);
        let chartId = window.uniqid();
        let $chart = $('<canvas/>')
        .attr('id',chartId);
        $chartContainer.append($chart);
        let cumulCAChart = new Chart(
            document.getElementById(chartId),
            chartConfig
        );

    }

    initializeLatestOrderTable(){
        var self = this;

        let $footer = $('<tr>')
        .append(
            $('<td>')
            .attr('colspan','100')
            .addClass('text-center')
            .append(
                $('<a/>')
                .attr('href',this.settings.latestOrderShowAllUrl)
                .addClass('btn btn-info')
                .append(window.translate('app.dashboard.order.latest.seeAll'))
            )
        );

        let fields = [
            'id',
            'restaurantName',
            'supplier { name }',
            'totalTTC',
            'netSale',
            'createdAt',
        ];

        this.table = new ListTable({
            '$container': this.$latestOrderTableContainer,
            'tableClass': 'table table-striped order-list',
            'id': 'list-orders',
            'length': this.settings.latestOrderLength,
            'showPagination': false,
            'footerContent': $footer,
            'graphQL': {
                'queryType': 'restaurantOrders',
                'fields': fields,
                'parameters': this.buildLatestOrderGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'createdAt',
                    'label': window.translate('restaurant.order.createdAt.label'),
                    'class': 'order-date',
                    'ordered': true,
                    'orderType': 'createdAt',
                    'orderDir': 'DESC',
                    'render': function(item,index){
                        return window.formatDate(item.node.createdAt,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'id',
                    'label': window.translate('restaurant.order.id.label'),
                    'class': 'order-id',
                    'render': function(item,index){
						
                        let $btnShow = $('<a/>')
                        .attr('href',"#")
                        .addClass('btn-order-show')
                        .attr('data-orderid',item.node.id)
                        .attr('title',window.translate('restaurant.order.actions.show.label'))
                        .append(item.node.id);
                        return $btnShow;
                    },
                },
                {
                    'name': 'restaurant',
                    'label': window.translate('restaurant.order.restaurant.label'),
                    'class': 'order-restaurant',
                    'render': function(item,index){
                        return item.node.restaurantName;
                    },
                },
                {
                    'name': 'supplier',
                    'label': window.translate('restaurant.order.supplier.label'),
                    'class': 'order-supplier',
                    'render': function(item,index){
                        return item.node.supplier.name;
                    },
                },
                {
                    'name': 'total',
                    'label': window.translate('total'),
                    'class': 'order-total',
                    'render': function(item,index){
                        return window.formatFloat(item.node.netSale) + ' &euro;';
                    },
                }
            ]
        });

    }

    buildLatestOrderGraphQLParameters(){
        let filters = {
            'status': 1
        };
        let parameters = {
            'filter' : filters
        };

        return parameters;
    }

    initializeDailyOrdersCard(){
        //this.$dailyOrdersCard
        this.$dailyOrdersCountValueContainer = $('.count-value',this.$dailyOrdersCard);
        this.$dailyOrderPreviousValueContainer = $('.count-previous-value',this.$dailyOrdersCard);


        this.$dailyOrdersCountValueContainer.html('')
        .append(window.App.generateLoader());

        this.$dailyOrderPreviousValueContainer.html('')
        .append(window.App.generateLoader());

    }

    initializeMonthOrdersCard(){
        //this.$monthOrdersCard
        this.$monthOrdersCountValueContainer = $('.count-value',this.$monthOrdersCard);
        this.$monthOrdersPreviousValueContainer = $('.count-previous-value',this.$monthOrdersCard);

        this.$monthOrdersCountValueContainer.html('')
        .append(window.App.generateLoader());
        
        this.$monthOrdersPreviousValueContainer.html('')
        .append(window.App.generateLoader());
    }

    initializeDailyCACard(){
        //this.$dailyCACard
        this.$dailyCACountValueContainer = $('.count-value',this.$dailyCACard);
        this.$dailyCAPreviousValueContainer = $('.count-previous-value',this.$dailyCACard);
        this.$dailyCATxMarginValueContainer = $('.txmargin-value',this.$dailyCACard);

        this.$dailyCACountValueContainer.html('')
        .append(window.App.generateLoader());
        
        this.$dailyCAPreviousValueContainer.html('')
        .append(window.App.generateLoader());

        this.$dailyCATxMarginValueContainer.html('')
        .append(window.App.generateLoader());
    }

    today(){
        let now = moment();
        return now;
    }

    initializeMonthCACard(){
        //this.$monthCACard
        this.$monthCACountValueContainer = $('.count-value',this.$monthCACard);
        this.$monthCAPreviousValueContainer = $('.count-previous-value',this.$monthCACard);
        this.$monthCATxMarginValueContainer = $('.txmargin-value',this.$monthCACard);

        this.$monthCACountValueContainer.html('')
        .append(window.App.generateLoader());
        
        this.$monthCAPreviousValueContainer.html('')
        .append(window.App.generateLoader());
        
        this.$monthCATxMarginValueContainer.html('')
        .append(window.App.generateLoader());
    }

    loadYesterdayData(){
        let today = this.today()
        let date = today
        .subtract(1,"day")
        .format('YYYY-MM-DD');
        this.loadAnalyseDataForDate(this.drawYesterdayData,date);
    }

    loadTodayData(){
        let today = this.today()
        let date = today.format('YYYY-MM-DD');
        this.loadAnalyseDataForDate(this.drawTodayData,date);
    }

    loadPreviousMonthData(){
        let today = this.today();

        let dateEnd = moment()
        .subtract(1,"month")
        .format('YYYY-MM-DD');


        let dateStart = moment()
        .subtract(2,"month")
        .format('YYYY-MM-DD');

        this.loadAnalyseDataForDate(this.drawPreviousMonthData,dateStart,dateEnd);
    }

    loadMonthData(){
        let date = moment()
        .subtract(1,"month")
        .format('YYYY-MM-DD');

        let dateEnd = moment().format('YYYY-MM-DD');

        this.loadAnalyseDataForDate(this.drawMonthData,date,dateEnd);

    }

    drawTodayData(data){
        this.$dailyOrdersCountValueContainer
        .html('')
        .append(data.nbOrders);

        this.$dailyCACountValueContainer
        .html('')
        .append(window.formatFloat(data.totalCA) + ' &euro;');

        this.$dailyCATxMarginValueContainer
        .html('')
        .append(window.formatFloat(data.rateSupplierMargin) +  '%');
    }

    drawYesterdayData(data){
        this.$dailyOrderPreviousValueContainer
        .html('')
        .append(data.nbOrders);

        this.$dailyCAPreviousValueContainer
        .html('')
        .append(window.formatFloat(data.totalCA) + ' &euro;');
    }

    drawPreviousMonthData(data){
        this.$monthOrdersPreviousValueContainer
        .html('')
        .append(data.nbOrders);

        this.$monthCAPreviousValueContainer.html('')
        .append(window.formatFloat(data.totalCA) + ' &euro;');
    }

    drawMonthData(data){
        this.$monthOrdersCountValueContainer
        .html('')
        .append(data.nbOrders);
        this.$monthCACountValueContainer
        .html('')
        .append(window.formatFloat(data.totalCA) + ' &euro;');
        this.$monthCATxMarginValueContainer
        .html('')
        .append(window.formatFloat(data.rateSupplierMargin) +  '%');
    }

    loadAnalyseDataForDate(callback,dateStart,dateEnd){

        let filters = {
            'orderedAt': '= '+dateStart
        };
        if(dateStart && dateEnd){
            filters.orderedAt = 'BETWEEN ' + dateStart + ' ' + dateEnd;
        }
        let parameters = {
            'filter' : filters
        };

        let fields = [
            'nbOrders',
            'totalMargin',
            'totalSupplierMargin',
            'rateSupplierMargin',
            'totalSupplierViewableMargin',
            'totalCA',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'RestaurantOrderMarginAnalyse',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                callback(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();

    }



}

module.exports = IndexView;

